module.exports = __webpack_public_path__ + "img/description2.0e53a5e6.jpg";